// extracted by mini-css-extract-plugin
module.exports = {"continue":"HT"};